import { render, staticRenderFns } from "./pointRoam.vue?vue&type=template&id=54abddfa&scoped=true&"
import script from "./pointRoam.vue?vue&type=script&lang=js&"
export * from "./pointRoam.vue?vue&type=script&lang=js&"
import style0 from "./pointRoam.vue?vue&type=style&index=0&id=54abddfa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54abddfa",
  null
  
)

export default component.exports